import { DiagonalCard } from "../common/DiagonalCard";
import { Hexagon } from "../common/Hexagon";

const formatCurrency = (value) => {
  if (!value && value !== 0) return "COP 0";
  return `COP ${Number(value).toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })}`;
};

const formatNumber = (value) => {
  if (!value && value !== 0) return "0";
  return Number(value).toLocaleString();
};

/**
 * Franja de KPIs de Órdenes, dentro de un DiagonalCard (README pantalla 2).
 * Visible sólo para ADMIN / ADMIN_ASSISTANT — la condición sigue en
 * OrderList.jsx, sin tocar.
 */
const StatsCards = ({
  totalOrders = 0,
  totalSales = 0,
  totalBonusPoints = 0,
  totalRoyaltyPoints = 0,
}) => {
  const cards = [
    {
      title: "Órdenes Totales",
      value: formatNumber(totalOrders),
      hint: "Total en el período",
      icon: "ri-file-list-3-line",
      color: "#4B36F0",
    },
    {
      title: "Ventas Netas",
      value: formatCurrency(totalSales),
      hint: "Sin comisiones",
      icon: "ri-money-dollar-circle-line",
      color: "#0F9A5A",
    },
    {
      title: "Puntos de Bono",
      value: formatNumber(totalBonusPoints),
      hint: "Total en el período",
      icon: "ri-star-line",
      color: "#7C3AED",
    },
    {
      title: "Puntos de Regalías",
      value: formatNumber(totalRoyaltyPoints),
      hint: "Total en el período",
      icon: "ri-award-line",
      color: "#D97706",
    },
  ];

  return (
    <DiagonalCard>
      <div className="ui-grid-kpis">
        {cards.map((card) => (
          <div key={card.title} className="d-flex align-items-center gap-3">
            <Hexagon size={46} color={card.color} icon={card.icon} />
            <div className="text-truncate">
              <div style={{ color: "#5A6187", fontSize: 12.5, fontWeight: 600 }}>{card.title}</div>
              <div style={{ fontSize: 23, fontWeight: 800, letterSpacing: "-0.025em", marginTop: 2, whiteSpace: "nowrap" }}>
                {card.value}
              </div>
              <div style={{ color: "#8A91AE", fontSize: 11, marginTop: 3 }}>{card.hint}</div>
            </div>
          </div>
        ))}
      </div>
    </DiagonalCard>
  );
};

export default StatsCards;
